import React, { useEffect, useState } from "react";
import Api from "../../../config/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import GifImg from "../../../assets/images/loader.gif";
// import InfiniteScroll from "react-infinite-scroller";
// import qs from "qs";
import { useForm } from "react-hook-form";
import { FaCheck, FaListUl } from "react-icons/fa";
import { BsFillPencilFill, BsEyeFill } from "react-icons/bs";
import StatusBadge from "../Application/Components/StatusBadge";
import ModalBox from "../../Components/Widget/ModalBox";
import Table from "../../Components/Widget/Table";
import Loader from "../../Components/Widget/Loader";
import TooltipWidget from "../../Components/Widget/TooltipWidget";
import { formatAadhaarNumber } from "../../../utils/aadhaar";

const ReliefApproveApplications = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [application, setApplication] = useState([]);
  const [isApplicationLoaded, setIsApplicationLoaded] = useState(false);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [selectedData, setSelectedData] = useState({
    id: "",
    status: "",
  });
  const [isModalShow, setIsModalShow] = useState(false);

  // === New state for "Previous Applications" ===
  const [previousApplications, setPreviousApplications] = useState([]);
  const [isPreviousModalShow, setIsPreviousModalShow] = useState(false);
  const [isPreviousLoading, setIsPreviousLoading] = useState(false);
  const [currentAadhaar, setCurrentAadhaar] = useState("");

  const admin = useSelector((state) => JSON.parse(state.authentication.admin));

  const modalClose = () => {
    setIsModalShow(false);
    reset();
    setSelectedData({
      id: "",
      status: "",
    });
  };

  const modalShow = (id, status) => {
    setIsModalShow(true);
    setSelectedData({
      id,
      status,
    });
  };

  // ===== Previous Applications modal handlers =====
  const previousModalClose = () => {
    setIsPreviousModalShow(false);
    setPreviousApplications([]);
    setCurrentAadhaar("");
    setIsPreviousLoading(false);
  };

  const openPreviousApplications = async (row) => {
    // ✅ exact field from API
    const aadhaarNumber = row?.aadhar_no;
  
    if (!aadhaarNumber) {
      toast.error("Aadhaar number not available for this application.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
  
    setCurrentAadhaar(aadhaarNumber);
    setIsPreviousModalShow(true);
    setIsPreviousLoading(true);
  
    try {
      const body = {
        // must match backend: $request->aadhar_no
        aadhar_no: aadhaarNumber,      
        exclude_id: row.id, // so current record is not included
      };
  
      const res = await Api("application_list", "POST", body, true);
  
      if (res.data.status === 1) {
        const previousData = Array.isArray(res.data.data) ? res.data.data : [];
        setPreviousApplications(
          previousData.filter((item) => item?.payment_status !== "R")
        );
      } else {
        setPreviousApplications([]);
        toast.error(res.data.message || "Failed to fetch previous applications", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      setPreviousApplications([]);
      toast.error(
        error?.message || "Something went wrong while fetching previous applications",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
    } finally {
      setIsPreviousLoading(false);
    }
  };
  // ===== end previous applications logic =====

  //Application Get
  const getApplication = async (
    status_id,
    page = 1,
    search = "",
    pageSize = perPage,
    sortByArg = sortBy,
    sortDirArg = sortDirection
  ) => {
    try {
      setIsLoading(true);
      const body = {
        status_id: status_id,
        page_no: page,
        per_page: pageSize,
        exclude_failed: true,
      };

      if (search.trim()) {
        body.search = search.trim();
      }

      if (sortByArg) {
        body.sort_by = sortByArg;
        body.sort_direction = sortDirArg;
      }

      const res = await Api("application_list", "POST", body, true);
      if (res.data.status === 1) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        const applicationData = Array.isArray(res.data.data) ? res.data.data : [];
        const filteredApplicationData = applicationData.filter(
          (item) => item?.payment_status !== "R"
        );
        const paginationData =
          res.data.pagination &&
          typeof res.data.pagination === "object"
            ? res.data.pagination
            : res.data &&
              typeof res.data === "object" &&
              res.data.page
            ? {
                page_no: res.data.page,
                per_page: res.data.per_page,
                total_records: res.data.total,
              }
            : null;

        setApplication(filteredApplicationData);

        if (paginationData) {
          setCurrentPage(paginationData.page_no || page);
          setTotalRecords(paginationData.total_records || 0);
          setPerPage(paginationData.per_page || pageSize);
        } else {
          const total =
            filteredApplicationData.length;
          setCurrentPage(page);
          setTotalRecords(total);
          setPerPage(pageSize);
        }

        setIsApplicationLoaded(true);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.data?.message || error.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };
  //Application Get

  const handleSearchInput = (value) => {
    setFilter(value);

    if (value.trim() === "") {
      setCurrentPage(1);
      setResetPaginationToggle((prev) => !prev);
      getApplication([3], 1, "", perPage);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setResetPaginationToggle((prev) => !prev);
    getApplication([3], 1, filter, perPage);
  };

  useEffect(() => {
    getApplication([3]); // pending statuses for Relief officer
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!admin) {
      reset({
        name: admin.full_name,
      });
    }
    // eslint-disable-next-line
  }, [reset]);

  const onSubmit = async (d) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("id", selectedData.id);
      formData.append("name", d?.name);
      formData.append("remark", d?.remark);
      formData.append("status", d?.status);

      if (d?.document?.length > 0) {
        formData.append("document", d?.document[0]);
      }

      const res = await Api("application_approve", "POST", formData);

      if (res.data.status === 1) {
        toast.success(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reset();
        modalClose();
        getApplication([3], currentPage, filter, perPage);
      } else if (res.data.status === 2) {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reset();
        modalClose();
        getApplication([3], currentPage, filter, perPage);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      name: "#",
      cell: (_row, index) => (currentPage - 1) * perPage + index + 1,
      width: "70px",
    },
    {
      name: "Application ID",
      selector: (row) => row.application_id,
      sortable: true,
      wrap: true,
    },
    {
      // name: "Applicant Image",
      name: "Applicant Passport Photo",
      selector: (row) => (
        <img
          src={row.applicant_default_img}
          alt="Applicant"
          style={{
            height: "70px",
            width: "100px",
            objectFit: "cover",
          }}
        />
      ),
    },
    {
      name: "Applicant Info",
      selector: (row) => (
        <>
          <div className="mb-1">{row.applicant_name}</div>
          <div>{row.mobile}</div>
        </>
      ),
    },
    {
      name: "District",
      selector: (row) => row.district?.district_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => {
        if (row?.payment_status === "R") {
          return (
            <>
              <StatusBadge status={row.status} />
              <span
                style={{
                  backgroundColor: "red",
                  color: "white",
                  padding: "4px 6px",
                  borderRadius: "12px",
                  fontSize: "11px",
                  marginLeft: "6px",
                }}
              >
                Failed
              </span>
            </>
          );
        } else {
          return <StatusBadge status={row.status} />;
        }
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="d-flex gap-1">
          <TooltipWidget title="View SDRF">
            <Link
              className="btn btn-warning btn-sm"
              // target="_blank"
              to={`/application/${window.btoa(row.id)}`}
            >
              <BsEyeFill />
            </Link>
          </TooltipWidget>

          <TooltipWidget title="Edit SDRF">
            <button
              className="btn btn-primary btn-sm"
              onClick={() =>
                navigate("/sdrf-1", {
                  state: {
                    id: row.id,
                    isEdit: true,
                  },
                })
              }
            >
              <BsFillPencilFill />
            </button>
          </TooltipWidget>

          {/* NEW: View previous applications (same Aadhaar) */}
          <TooltipWidget title="View applications (same Aadhaar)">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => openPreviousApplications(row)}
            >
              <FaListUl />
            </button>
          </TooltipWidget>

          <TooltipWidget title="Approve/Review/Reject SDRF">
            <button
              className="btn btn-success btn-sm"
              onClick={() => {
                modalShow(row.id, "3");
              }}
            >
              <FaCheck />
            </button>
          </TooltipWidget>
        </div>
      ),
      minWidth: "220px",
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getApplication([3], page, filter, perPage);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    setResetPaginationToggle((prev) => !prev);
    getApplication([3], 1, filter, newPerPage);
  };

  const handleSort = (column, direction) => {
    const colMap = {
      "Application ID": "application_id",
      "District": "district_name",
      "Aadhar No": "aadhar_no",
      "Status": "status",
    };
    const field = colMap[column.name] || "";
    setSortBy(field);
    setSortDirection(direction);
    setCurrentPage(1);
    getApplication([3], 1, filter, perPage, field, direction);
  };

  return (
    <>
      <div className="bg-white p-3 rounded p-3 shadow">
        <div className="mb-3">
          <div className="row g-2">
            <div className="col-lg-4 col-md-4">
              <h5 className="text-dark">Approve Applications</h5>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="">
                <input
                  type="text"
                  placeholder="Search Application"
                  className="form-control"
                  value={filter}
                  onChange={(e) => handleSearchInput(e.target.value)}
                  disabled={isLoading}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-2">
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={isLoading}
              >
                Search
              </button>
            </div>
          </div>
        </div>
        {isApplicationLoaded && (
          <div className="mb-3">
            <small className="text-muted">
              Showing {totalRecords === 0 ? 0 : (currentPage - 1) * perPage + 1} to{" "}
              {totalRecords === 0 ? 0 : Math.min(currentPage * perPage, totalRecords)} of{" "}
              {totalRecords} approve applications
            </small>
          </div>
        )}
        <div>
          {isApplicationLoaded ? (
            <Table
              columns={columns}
              data={application}
              progressPending={isLoading}
              pagination
              paginationServer
              paginationTotalRows={totalRecords}
              paginationDefaultPage={currentPage}
              paginationPerPage={perPage}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              paginationResetDefaultPage={resetPaginationToggle}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              sortServer
              onSort={handleSort}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>

      {/* Existing Approve / Review / Reject Modal */}
      <ModalBox show={isModalShow} hide={modalClose} title="Approve SDRF">
        <div className="p-2">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
              <div className="col-12">
                <div className="">
                  <label>
                    Name
                    <span className="text-danger fw-bold">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    {...register("name", {
                      required: true,
                    })}
                    disabled={true}
                  />
                  {errors.name && (
                    <div className="error_line">Name is required</div>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="">
                  <label>
                    Comment/Remark
                    <span className="text-danger fw-bold">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    {...register("remark", {
                      required: true,
                    })}
                    rows={5}
                  ></textarea>
                  {errors.remark && (
                    <div className="error_line">
                      Comment/Remark is required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="">
                  <label>Upload supporting file (if any)</label>
                  <input
                    className="form-control"
                    type="file"
                    {...register("document")}
                  />
                  {errors.document && (
                    <div className="error_line">
                      Supporting file is required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div className="">
                  <label>
                    Select Status{" "}
                    <span className="text-danger fw-bold">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("status", {
                      required: true,
                    })}
                  >
                    <option value="">Select Status</option>
                    <option value="4">Nodal Officer Review</option>
                    <option value="5">Approve</option>
                    <option value="7">Reject</option>
                  </select>
                  {errors.status && (
                    <div className="error_line">Status is required</div>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={isLoading}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ModalBox>

      {/* NEW: Previous Applications Modal */}
      <ModalBox
        show={isPreviousModalShow}
        hide={previousModalClose}
        size = "lg"
        title={
          currentAadhaar
            ? `View applications (Same Aadhaar: ${formatAadhaarNumber(
                currentAadhaar
              )})`
            : "View applications (Same Aadhaar)"
        }
      >
        <div className="p-2">
          {isPreviousLoading ? (
            <Loader />
          ) : previousApplications.length === 0 ? (
            <div className="alert alert-info m-0">
              No previously approved applications found for this Aadhaar.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Application ID</th>
                    <th>Applicant Name</th>
                    <th>District</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {previousApplications.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.application_id}</td>
                      <td>{item.applicant_name}</td>
                      <td>{item.district?.district_name}</td>
                      <td>
                        <StatusBadge status={item.status} />
                      </td>
                      <td>
                        {/* Open detail in NEW TAB */}
                        <a
                          href={`/application/${window.btoa(item.id)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-warning btn-sm"
                        >
                          <BsEyeFill />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </ModalBox>
    </>
  );
};

export default ReliefApproveApplications;
